import { SemVer } from 'semver';

export type Platforms = 'samsung' | 'lg' | 'vewd' | 'philips' | 'UNKNOWN';

export type TvModelYear =
  | 'UNKNOWN'
  | '2014'
  | '2015'
  | '2016'
  | '2017'
  | '2018'
  | '2019'
  | '2020'
  | '2021'
  | '2022'
  | '2023'
  | '2024'
  | '2025';

export interface VersionUtils {
  semver: SemVer;
  equal: (compareVersion: string) => boolean;
  greaterThan: (compareVersion: string) => boolean;
  greaterThanOrEqual: (compareVersion: string) => boolean;
  lessThan: (compareVersion: string) => boolean;
  lessThanOrEqual: (compareVersion: string) => boolean;
}

export type DeviceUtils = {
  platform: Platforms;
  version: VersionUtils;
  isDiscontinued: boolean;
  isModern: boolean;
  isLowEnd: boolean;
  modelYear: TvModelYear;
  isMouseSupported: boolean;
  isScrollSupported: boolean;
};

export const deviceUtilsDefault: DeviceUtils = {
  version: {
    semver: new SemVer('0.0.0-experimental-dev-123456789'),
    equal: () => false,
    greaterThan: () => false,
    greaterThanOrEqual: () => false,
    lessThan: () => false,
    lessThanOrEqual: () => false
  },
  isDiscontinued: false,
  isModern: true,
  isLowEnd: false,
  modelYear: 'UNKNOWN',
  platform: 'UNKNOWN',
  isMouseSupported: false,
  isScrollSupported: false
};
